module.exports = __webpack_public_path__ + "static/img/11.666b79d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/11.png
// module id = kP8F
// module chunks = 0